import type { FC } from "react";

import { cn, makeBreakpointClassName } from "@/ui/lib/utils";
import {
  BASE_TEXT_CONTROL_SIZE_CLASS_MAP,
  RESPONSIVE_TEXT_CONTROL_SIZE_CLASS_MAP,
  TEXT_CONTROL_DEFAULTS,
  TTextControlProps,
} from "@/ui/components/typography/TextControl/TextControl.config";
import {
  TYPOGRAPHY_COLORS_CLASS_MAP,
  TYPOGRAPHY_RESPONSIVE_ALIGNMENTS_CLASS_MAP,
  TYPOGRAPHY_WHITESPACES_CLASS_MAP,
} from "@/ui/components/typography/typography.config";

export const TextControl: FC<TTextControlProps> = (
  {
    tag: Tag = TEXT_CONTROL_DEFAULTS.tag,
    size = TEXT_CONTROL_DEFAULTS.size,
    color = TEXT_CONTROL_DEFAULTS.color,
    align = TEXT_CONTROL_DEFAULTS.align,
    whitespace = TEXT_CONTROL_DEFAULTS.whitespace,
    isResponsive = TEXT_CONTROL_DEFAULTS.isResponsive,
    "data-component": component = TEXT_CONTROL_DEFAULTS["data-component"],
    children,
    className,
    ...props
  },
) => (
  <Tag
    {...props}
    data-component={component}
    className={cn(
      makeBreakpointClassName(align, TYPOGRAPHY_RESPONSIVE_ALIGNMENTS_CLASS_MAP, "left"),
      TYPOGRAPHY_WHITESPACES_CLASS_MAP[whitespace],
      TYPOGRAPHY_COLORS_CLASS_MAP[color],
      isResponsive ?
        RESPONSIVE_TEXT_CONTROL_SIZE_CLASS_MAP[size] :
        BASE_TEXT_CONTROL_SIZE_CLASS_MAP[size],
      className,
    )
    }
  >
    { children }
  </Tag>
);

TextControl.displayName = "TextControl";
